import React, { Fragment } from "react";
import { useField } from "formik";

export default function FormField({
  label,
  icon,
  placeholder,
  ...props
}: React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
> & { placeholder?: string; name: string; label?: string; icon?: any }) {
  const [field, meta, helpers] = useField(props);

  return (
    <Fragment>
      {label && (
        <label htmlFor={props.name} className="block mb-1 ml-1">
          {label}
        </label>
      )}
      <div className="relative justify-center items-center">
        <input
          id={props.name}
          placeholder={placeholder}
          {...props}
          {...field}
          className="input-field"
        />
        {icon && (
          <img
            src={icon}
            className="absolute right-2 top-2 bottom-0 mt-0.5"
            alt=""
          />
        )}
      </div>
      {meta.touched && meta.error ? (
        <div className="text-red-800 text-base normal-case font-primary mb-2 ml-1 mt-1">
          {meta.error}
        </div>
      ) : (
        <span className="mb-3 block" />
      )}
    </Fragment>
  );
}
